const metodos = {
  formatar: valor => valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace('R$', 'R$ '),

  removerFormatacao: (valor) => {
    if (valor === null) { return 0.0; }
    if (typeof valor === 'number') return valor;

    const valorSemVirgulaECifrao = valor.replace(/\./g, '').replace(',', '.').replace('R$', '');

    return parseFloat(valorSemVirgulaECifrao);
  },
};

/* eslint-disable no-param-reassign, no-unused-vars */
const plugin = {
  install(Vue, options) {
    Vue.prototype.$moeda = metodos;
  },
};

export default plugin;



// WEBPACK FOOTER //
// ./src/plugins/moeda.js